module.exports = __webpack_public_path__ + "media/images/icon-empty-nochart-2d304ccee320f47e8489eae08118593d.png";